/* @flow */

import * as React from 'react';
import { Route } from 'react-router-dom';
import RequireForAccess from 'react-access';

import { apiService, getStore, getStores } from 'services/ServiceRegistry';
import navigationService from 'services/NavigationService';

import Login from 'views/AccountLogin/LoginForm';
import Welcome from 'forms/CreateAccount/Welcome';

import UnauthorisedAccess from 'components/UnauthorisedAccess/UnauthorisedAccess';

import NewAccount from 'views/AccountLogin/NewAccount';

import UserDetailsForm from '../forms/CreateAccount/UserDetailsForm';
import type { TypeComponent, TypeRoute } from './types';
import AccountNumbersForm from '../forms/CreateAccount/AccountNumbersForm';
import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary';
import { allRoles } from 'permissions/general';
import { getRoutes } from './index';
import { DocumentTitle } from '../components/DocumentTitle/DocumentTitle';

class Forbidden extends React.Component<*> {
  componentDidMount() {
    navigationService.goBack();
  }

  render(): TypeComponent {
    return <div>Forbidden</div>;
  }
}

/**
 * Find if user is Authorised to view a page.
 *
 * @param route
 * @returns {*}
 */
export function getAuthorizedComponent(route: TypeRoute): TypeComponent {
  if (route.auth && !apiService.isLoggedIn()) {
    return Login;
  }

  const deny: boolean = route.deny ? route.deny.indexOf(apiService.getRole()) !== -1 : false;

  return deny ? Forbidden : route.pageComponent;
}

/**
 * Render all available routes for this user with given permissions.
 * This function is responsible for routes and links user is allowed to see.
 *
 * @param routes
 * @param loginRoutes
 * @param isUserSignedUp
 * @param userStore
 * @param routing
 * @returns {any[]}
 */
export function renderRoutes(
  { routes, loginRoutes, isUserSignedUp },
  { userStore }
): Array<TypeComponent> {
  const badRoutes: Array<*> = routes.filter((r: *) => !r.permissions);

  if (badRoutes.length > 0) {
    const err: string = `Found ${badRoutes.length} bad routes. See console.`; //`
    console.log(err);
    badRoutes.forEach((r: *) => {
      console.log(r);
    });
    throw new Error(err);
  }

  let vComponent: Object = {};

  switch (isUserSignedUp[1]) {
    case 1:
      vComponent = NewAccount;
      break;
    case 2:
      vComponent = UserDetailsForm;
      break;
    case 3:
      vComponent = Welcome;
      break;
  }

  let vRoutes = routes;

  (isUserSignedUp[1] === 1 || isUserSignedUp[1] === 2 || isUserSignedUp[1] === 3) &&
    (vRoutes = [
      ...loginRoutes,

      // TODO: These should be refactored to more specific route files
      {
        path: '/email-verified',
        component: UserDetailsForm,
        exact: true,
        permissions: allRoles,
      },
      {
        path: '/account-numbers',
        component: AccountNumbersForm,
        exact: true,
        permissions: allRoles,
      },
      {
        path: '/welcome',
        component: Welcome,
        exact: true,
        permissions: allRoles,
      },
      {
        path: '*',
        component: vComponent,
        exact: true,
        permissions: allRoles,
      },
    ]);

  return vRoutes.map((route, index) => (
    <Route
      key={`${route.path}-${index}`}
      path={route.path}
      exact={route.exact}
      render={(props: Object) => {
        return (
          <RequireForAccess
            permissions={route.permissions}
            invalidAccessComponent={<UnauthorisedAccess />}
          >
            <ErrorBoundary>
              <DocumentTitle routes={getRoutes(userStore)} stores={getStore(route.store)} />
              <route.component {...props} />
            </ErrorBoundary>
          </RequireForAccess>
        );
      }}
    />
  ));
}
